import React, { useState, useEffect, useRef } from 'react';
import styles from './ItemNavigation.module.css';

const ItemNavigation = ({ items, typeContainer, father,setTypeState }) => {
  const [activeId, setActiveId] = useState("textBox");
    const isProgrammaticScroll = useRef(false); 
  const [checkedItems, setCheckedItems] = useState(false);

  const handleClick = (id,index) => {
    setTypeState && setTypeState(id)
    setActiveId(id);
   setCheckedItems(index)
    isProgrammaticScroll.current = true;

    const container = document.getElementById('scrollContainer');
    const element = document.getElementById(id);

    if (container && element) {
      const yOffset = -100;
      const y = element.offsetTop + yOffset;

      container.scrollTo({
        top: y,
        behavior: 'smooth',
      });

      setTimeout(() => {
        isProgrammaticScroll.current = false;
      }, 500); 
    }
  };

  useEffect(() => {
    const container = document.getElementById('scrollContainer');
    if (!container) return;

    const handleScroll = () => {
      if (isProgrammaticScroll.current) return; 

      const scrollPosition = container.scrollTop;
      const offset = 110;

      let currentId = null;
      for (const item of items) {
        const el = document.getElementById(item.id);
        if (el && el.offsetTop - offset <= scrollPosition) {
          currentId = item.id;
        }
      }

      if (currentId !== activeId) {
        setActiveId(currentId);
      }
    };

    container.addEventListener('scroll', handleScroll);

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [items, activeId]);


  const handleScroll = (sectionRef) => {
    sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <ul className={styles.ItemNavigation}>
      {items.map(({ id, label,Icon,ref },index) => (
        <li
          key={id}
          onClick={() => handleClick(id,index)}
          className={activeId === id && father !== "asset" ? styles.active : ""}
        >
          <button onClick={() => {ref && handleScroll(ref) } } type="button"> 
          {Icon && (
        <Icon
          className={
            activeId === id && father !== "asset"
              ? id === "parameters"
                ? styles.activeIconStoke
                : styles.activeIcon
              : id === "parameters"
              ? styles.iconStoke
              : styles.icon
          }
        />
      )}
            {label}
          </button>
        {typeContainer === "popup" && father === "asset" && 
           <input type="checkbox" checked={checkedItems === index} style={{opacity: checkedItems === index ? 1 : 0 }}/>
           }
        </li>
      ))}
    </ul>
  );
};

export default ItemNavigation;
